import React, { Component } from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";

import RuleOutlinedIcon from "@mui/icons-material/RuleOutlined";
import LinkOffOutlinedIcon from "@mui/icons-material/LinkOffOutlined";
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import UpdateOutlinedIcon from "@mui/icons-material/UpdateOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";

import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";

import DashboardHeader from "./DashboardHeader";
import SummaryCard from "../../components/dashlibs/SummaryCard";
import SectionCard from "../../components/dashlibs/SectionCard";
import StatusBadge from "../../components/dashlibs/StatusBadge";
import AlertList from "../../components/dashlibs/AlertList";
import { MockBarChart, MockTrendChart } from "../../components/dashlibs/MockChart";
import { DashboardPageProps } from "./dashboard.types";

import type { ChartTone } from "../../components/charts";
import { DonutChart, AreaTrendChart, BarChart, TreemapChart, BulletChart } from "../../components/charts";

const qualityTrend = [62, 64, 66, 68, 69, 71, 72, 74, 76, 78, 80, 82];

const missingMappings = [
  { label: "Activités sans KPI", value: 21, color: "#C0392B" },
  { label: "Lignes sans produit", value: 14, color: "#D68910" },
  { label: "Lignes sans location", value: 18, color: "#A93226" },
  { label: "Objets sans axe", value: 9, color: "#2471A3" },
];

const importQuality = [
  { label: "Imports complets", value: 82, color: "#116B43" },
  { label: "Imports partiels", value: 29, color: "#D68910" },
  { label: "Imports rejetés", value: 11, color: "#C0392B" },
  { label: "Fichiers en revue", value: 24, color: "#163A5F" },
];

const staleData = [
  { label: "Budget lines", value: 33, color: "#D68910" },
  { label: "KPI records", value: 21, color: "#2471A3" },
  { label: "Activity status", value: 41, color: "#C0392B" },
  { label: "Staff plans", value: 17, color: "#163A5F" },
];

const dqAlerts = [
  {
    title: "Activités non reliées aux KPI",
    description: "Des activités restent exécutées sans rattachement complet au dispositif de performance.",
    tone: "danger" as const,
  },
  {
    title: "Imports partiellement mappés",
    description: "Certains chargements contiennent encore des lignes incomplètement classifiées.",
    tone: "warning" as const,
  },
  {
    title: "Qualité des validations en progrès",
    description: "La part des données complètement validées continue de s’améliorer.",
    tone: "success" as const,
  },
];

const exceptionMix = [
  { label: "Orphelins", value: 46, color: "#C0392B" },
  { label: "Référentiels manquants", value: 31, color: "#D68910" },
  { label: "Incohérences workflow", value: 24, color: "#2471A3" },
  { label: "Données périmées", value: 39, color: "#163A5F" },
];
export default class DataQualityDashboard extends Component<DashboardPageProps,any> {
  //const { period,cycle} = sharedFilters;
render(){
  const {userData,dashData,sharedFilters,filterOptions,onFilterChange,onRefresh} = this.props;
  const {meta,sections={},summaryCards=[]} = dashData || {};

  const {qualityChecks={},qualityByDomain={},masterDataCoverage={},dataQualityAlerts={}} = sections;

  // 'icon', 'shield',
  // 'icon', 'warning',
  // 'icon', 'danger',
  // 'icon', 'info',

  const iconMap: any = {
    info: <InfoOutlinedIcon />,
    warning: <WarningAmberOutlinedIcon />,
    shield: <ShieldOutlinedIcon />,
    danger: <ErrorOutlineOutlinedIcon />,
  }

    
  return (
    <Box sx={{ p: { xs: 2, md: 3 }, display: "grid", gap: 2.5 }}>
      <DashboardHeader
        title="Dashboard Qualité des Données & Contrôle"
        subtitle="Vue consolidée de la qualité des données, des exceptions de contrôle, des imports et des anomalies structurelles."
        userData={userData}
        sharedFilters={sharedFilters}
        filterOptions={filterOptions}
        onFilterChange={onFilterChange}
        onRefresh={onRefresh}
      />

      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 2 }}>
        {(summaryCards || []).map((card: any) => (
        <SummaryCard
          key={card.code}
          title={card.label}
          value={card.valueFormatted}
          subtitle={card.subtitle}
          delta={card.deltaFormatted}
          tone={card.tone}
          icon={iconMap[card.icon] || <AccountBalanceWalletOutlinedIcon />}
        />
        ))}
      </Box>

      <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: { xs: "1fr", lg: "1.35fr 1fr" } }}>
        <SectionCard
          title={qualityChecks.title || ""}
          subtitle={qualityChecks.subtitle || ""}
        >
          <BulletChart  data={(qualityChecks.data || [])} />
        </SectionCard>

        <SectionCard
          title={qualityByDomain.title || ""}
          subtitle={qualityByDomain.subtitle || ""}
        >
          <TreemapChart data={qualityByDomain.data || []} />
        </SectionCard>
      </Box>

      <Box sx={{ display: "grid", gap: 2, gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" } }}>
        <SectionCard
          title={masterDataCoverage.title || ""}
          subtitle={masterDataCoverage.subtitle || ""}
        >
          <DonutChart data={(masterDataCoverage.data || [])} />
        </SectionCard>

        <SectionCard
          title={dataQualityAlerts.title || ""}
          subtitle={dataQualityAlerts.subtitle || ""}
        >
          <AlertList items={dataQualityAlerts.data || []} />
        </SectionCard>
      </Box>

      

      {/* 
      <Box
        sx={{
          display: "grid",
          gap: 2,
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            lg: "repeat(6, 1fr)",
          },
        }}
      >
        <SummaryCard
          title="Score qualité"
          value="82%"
          subtitle="Complétude / cohérence"
          delta="+3 pts"
          tone="success"
          icon={<FactCheckOutlinedIcon />}
        />
        <SummaryCard
          title="Exceptions"
          value="47"
          subtitle="Anomalies ouvertes"
          delta="11 critiques"
          tone="danger"
          icon={<ErrorOutlineOutlinedIcon />}
        />
        <SummaryCard
          title="Mappings manquants"
          value="23"
          subtitle="Relations incomplètes"
          delta="À corriger"
          tone="warning"
          icon={<LinkOffOutlinedIcon />}
        />
        <SummaryCard
          title="Imports analysés"
          value="68"
          subtitle="Fichiers traités"
          delta="FY2025"
          tone="info"
          icon={<CloudUploadOutlinedIcon />}
        />
        <SummaryCard
          title="Contrôles validés"
          value="91%"
          subtitle="Règles exécutées"
          delta="Stable"
          tone="success"
          icon={<RuleOutlinedIcon />}
        />
        <SummaryCard
          title="Données périmées"
          value="17"
          subtitle="Mises à jour attendues"
          delta="+2"
          tone="warning"
          icon={<UpdateOutlinedIcon />}
        />
      </Box>

      <Grid container spacing={2}>
        <Grid size={{ xs: 12, lg: 8 }}>
          <SectionCard
            title="Tendance qualité des données"
            subtitle="Évolution du score global de qualité et de contrôle."
            action={<StatusBadge label="Quality trend" tone="info" />}
          >
            <MockTrendChart points={qualityTrend} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <SectionCard
            title="Alertes de contrôle"
            subtitle="Anomalies prioritaires pour la fiabilité du système."
          >
            <AlertList items={dqAlerts} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <SectionCard
            title="Mappings manquants"
            subtitle="Liens structurels incomplets dans le modèle."
          >
            <MockBarChart data={missingMappings} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <SectionCard
            title="Qualité des imports"
            subtitle="Lecture simplifiée des chargements et validations."
          >
            <MockBarChart data={importQuality} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 4 }}>
          <SectionCard
            title="Données périmées"
            subtitle="Objets nécessitant une mise à jour ou revue."
          >
            <MockBarChart data={staleData} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 6 }}>
          <SectionCard
            title="Mix des exceptions"
            subtitle="Répartition simplifiée des anomalies détectées."
            action={<StatusBadge label="Exceptions" tone="warning" />}
          >
            <MockBarChart data={exceptionMix} />
          </SectionCard>
        </Grid>

        <Grid size={{ xs: 12, lg: 6 }}>
          <SectionCard
            title="Lecture gouvernance"
            subtitle="Messages clés sur la fiabilité et les contrôles."
          >
            <Stack spacing={1.25}>
              {[
                ["La qualité s’améliore mais reste dépendante des mappings", "Les relations incomplètes entre activités, KPI, lignes et référentiels restent une cause majeure d’exception."],
                ["Les imports doivent être mieux sécurisés", "La qualité des chargements conditionne directement la fiabilité des dashboards et des analyses de gestion."],
                ["La surveillance des données périmées est essentielle", "Des statuts ou objets non mis à jour peuvent produire des lectures trompeuses pour le management."],
              ].map(([title, desc]) => (
                <Box
                  key={title}
                  sx={{
                    p: 1.5,
                    borderRadius: "10px",
                    border: "1px solid #E2E8EE",
                    bgcolor: "#FFFFFF",
                  }}
                >
                  <Typography sx={{ fontSize: 13, fontWeight: 800, color: "#17324D" }}>
                    {title}
                  </Typography>
                  <Typography sx={{ fontSize: 13, color: "#66788A", mt: 0.5, lineHeight: 1.65 }}>
                    {desc}
                  </Typography>
                </Box>
              ))}
            </Stack>
          </SectionCard>
        </Grid>
      </Grid> */}
    </Box>
  );
}
}
